import React from 'react';
import { AuthWrapper, PasswordInput, AuthFormHeader } from '@src/features/auth/components';
import { useResetPasswordForm } from '@src/features/auth/hooks';
import { REQUIRED_VALIDATION_TEXT } from '@src/core/config';
import { ArcButton, ArcStack } from '@src/core/ui';

const ResetPasswordPage: React.FC = () => {
  const { register, formState: { errors }, onSubmit, isLoading } = useResetPasswordForm();

  return (
    <AuthWrapper>
      <AuthFormHeader
        title='Create a new password'
        subtitle='Enter and confirm your new password to continue'
      />
      <ArcStack
        mt={3}
        spacing={5.5}
        component='form'
        alignItems='center'
        onSubmit={onSubmit}>
        <ArcStack width='100%' spacing={3}>
          <PasswordInput
            register={register('newPassword', { required: REQUIRED_VALIDATION_TEXT })}
            error={errors.newPassword}
            label='Password'
          />
          <PasswordInput
            register={register('newPassword2', { required: REQUIRED_VALIDATION_TEXT })}
            error={errors.newPassword2}
            label='Re-enter Password'
          />
        </ArcStack>
        <ArcButton.brand
          isLoading={isLoading}
          type='submit'
          sx={{ width: 300 }}>
          Reset password
        </ArcButton.brand>
      </ArcStack>
    </AuthWrapper>
  );
};

export default ResetPasswordPage;